import useAppModal from 'hooks/useAppModal';
import ViewProtectedPropertiesModal, {
  VIEW_PROTECTED_PROPERTIES_MODAL_ID,
} from './ViewProtectedPropertiesModal';

const useViewProtectedPropertiesModal = () => {
  const { openModal } = useAppModal();

  const openViewProtectedPropertiesModal = ({
    protectedPropertyUids,
  }: {
    protectedPropertyUids: string[];
  }) => {
    openModal({
      id: VIEW_PROTECTED_PROPERTIES_MODAL_ID,
      customContent: (
        <ViewProtectedPropertiesModal
          protectedPropertyUids={protectedPropertyUids}
        />
      ),
    });
  };

  return { openViewProtectedPropertiesModal };
};

export default useViewProtectedPropertiesModal;
